'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mightyFields = require('../../lib/mighty-fields');

var _constants = require('../../constants');

var _LawFirmModalFieldSets = require('./LawFirmModalFieldSets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var MODEL_TYPES = _constants.AppConstants.MODEL_TYPES;
var LawFirmModal = (_dec = (0, _mobxReact.inject)('CaseStore', 'Clients', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(LawFirmModal, _Component);

  function LawFirmModal() {
    _classCallCheck(this, LawFirmModal);

    return _possibleConstructorReturn(this, (LawFirmModal.__proto__ || Object.getPrototypeOf(LawFirmModal)).apply(this, arguments));
  }

  _createClass(LawFirmModal, [{
    key: 'processVerifiedLawFirm',
    value: function processVerifiedLawFirm(lawfirm) {
      // wipe id and address_id to guarantee new objects are created when selecting a verified law firm
      lawfirm.verified_lawfirm = lawfirm.id;
      delete lawfirm.id;
      lawfirm.address && delete lawfirm.address.id;

      return lawfirm;
    }
  }, {
    key: 'createOrUpdateLawFirm',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(lawfirm) {
        var editOnly, updateExisting, createNew, savedLawFirm;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                editOnly = this.props.editOnly, updateExisting = editOnly && lawfirm.id, createNew = !editOnly && !lawfirm.id;
                savedLawFirm = lawfirm;

                if (!updateExisting) {
                  _context.next = 7;
                  break;
                }

                // verified_lawfirm comes back in retrieve, but should not be modifiable
                delete lawfirm.verified_lawfirm;
                _context.next = 6;
                return this.lawFirmClient.update(lawfirm.id, lawfirm);

              case 6:
                savedLawFirm = _context.sent;

              case 7:
                if (!createNew) {
                  _context.next = 11;
                  break;
                }

                _context.next = 10;
                return this.lawFirmClient.create(lawfirm);

              case 10:
                savedLawFirm = _context.sent;

              case 11:
                return _context.abrupt('return', savedLawFirm);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createOrUpdateLawFirm(_x) {
        return _ref.apply(this, arguments);
      }

      return createOrUpdateLawFirm;
    }()
  }, {
    key: 'handleSave',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var _props, CaseStore, editOnly, caseId, lawfirmData, isVerifiedLawFirm, submitData, lawfirm, assignToCase;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props = this.props;
                CaseStore = _props.CaseStore;
                editOnly = _props.editOnly;
                caseId = data.caseId;
                lawfirmData = data.lawfirmData;
                isVerifiedLawFirm = lawfirmData.type === MODEL_TYPES.verifiedLawFirm.key;
                submitData = isVerifiedLawFirm ? this.processVerifiedLawFirm(lawfirmData) : lawfirmData;
                _context2.next = 9;
                return this.createOrUpdateLawFirm(submitData);

              case 9:
                lawfirm = _context2.sent;
                assignToCase = caseId && !editOnly;
                _context2.t0 = assignToCase;

                if (!_context2.t0) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 15;
                return CaseStore.update({ caseId: caseId, data: { lawfirm: lawfirm.id } });

              case 15:
                return _context2.abrupt('return', lawfirm);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSave(_x2) {
        return _ref2.apply(this, arguments);
      }

      return handleSave;
    }()
  }, {
    key: 'handleSaveNested',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var lawfirm, isNewLawFirm;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                lawfirm = data.lawfirm, isNewLawFirm = !lawfirm.type;
                _context3.next = 3;
                return this.handleValidSubmit(lawfirm, isNewLawFirm);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleSaveNested(_x3) {
        return _ref3.apply(this, arguments);
      }

      return handleSaveNested;
    }()
  }, {
    key: 'handleQuickAdd',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
        var _props2, CaseStore, UiStore, caseId;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _props2 = this.props, CaseStore = _props2.CaseStore, UiStore = _props2.UiStore, caseId = _props2.caseId;
                _context4.next = 3;
                return CaseStore.update({ caseId: caseId, data: { lawfirm: data.lawfirm } });

              case 3:
                UiStore.modals.LawFirm.close();

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleQuickAdd(_x4) {
        return _ref4.apply(this, arguments);
      }

      return handleQuickAdd;
    }()
  }, {
    key: 'handleValidSubmit',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(lawfirm) {
        var manual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var _props3, SessionStore, UiStore, onSave, caseId, eventData;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _props3 = this.props, SessionStore = _props3.SessionStore, UiStore = _props3.UiStore, onSave = _props3.onSave, caseId = _props3.caseId, eventData = (0, _omit3.default)(lawfirm, ['address', 'fax_number', 'phone_number', 'website', 'verified_lawfirm']);


                manual && SessionStore.trackEvent('MANUAL_ADD_CASE_LAWFIRM_INFO', _extends({ caseId: caseId }, eventData));

                _context5.next = 4;
                return onSave(this.handleSave, lawfirm);

              case 4:
                UiStore.modals.LawFirm.close();

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handleValidSubmit(_x5) {
        return _ref5.apply(this, arguments);
      }

      return handleValidSubmit;
    }()
  }, {
    key: 'quickAddFormat',
    value: function quickAddFormat(object) {
      return object.lawfirm.name;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          editOnly = _props4.editOnly,
          UiStore = _props4.UiStore,
          lawfirm = _props4.lawfirm,
          contactRelatedLawfirms = _props4.contactRelatedLawfirms,
          quickAddLawfirms = contactRelatedLawfirms.map(function (lawfirm) {
        return { id: lawfirm.id, lawfirm: lawfirm };
      });


      if (editOnly) {
        return _react2.default.createElement(_mightyFields.FormModal, {
          fieldSets: _LawFirmModalFieldSets.EDIT_FIELD_SETS,
          model: lawfirm,
          onClose: UiStore.modals.LawFirm.close,
          onSave: this.handleValidSubmit,
          title: 'Edit Law Firm'
        });
      }

      return _react2.default.createElement(_mightyFields.FormModal, {
        className: 'modal-lawfirm',
        fieldSets: _LawFirmModalFieldSets.FIELD_SETS,
        model: { lawfirm: lawfirm },
        onClose: UiStore.modals.LawFirm.close,
        onSave: this.handleSaveNested,
        quickAdd: quickAddLawfirms,
        quickAddFormat: this.quickAddFormat,
        quickAddOnSelect: this.handleQuickAdd,
        quickAddTitle: 'Associated Lawfirms',
        title: 'Edit Law Firm'
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'lawFirmClient',
    get: function get() {
      var Clients = this.props.Clients;


      return Clients.lawFirms;
    }
  }]);

  return LawFirmModal;
}(_react.Component), _class3.defaultProps = {
  contactRelatedLawfirms: [],
  editOnly: false
}, _class3.propTypes = {
  caseId: _propTypes2.default.string,
  Clients: _propTypes2.default.object.isRequired,
  contactRelatedLawfirms: _mobxReact.propTypes.arrayOrObservableArray,
  editOnly: _propTypes2.default.bool,
  lawfirm: _propTypes2.default.object,
  onSave: _propTypes2.default.func.isRequired,
  SessionStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleSave', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleSave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSaveNested', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleSaveNested'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleQuickAdd', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleQuickAdd'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = LawFirmModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MODEL_TYPES, 'MODEL_TYPES', '/app/src/components/common-modal-lawfirm/LawFirmModal.js');
  reactHotLoader.register(LawFirmModal, 'LawFirmModal', '/app/src/components/common-modal-lawfirm/LawFirmModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-modal-lawfirm/LawFirmModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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